import Pricing from "../components/Pricing";
import Faqs from "../components/Faqs";
import Subscribe from "../components/Subscribe";
import Footer from "../components/Footer";
import Contact from "../components/Contact";
import Testimonial from "../components/Testimonial";
import Navigation from "../components/Navigation";
import Hero from "../components/Hero";
import Features from "../components/Features";
import Steps from "../components/Steps";
import Stories from "../components/Stories";
import Brand from "../components/Brand";
import ScrollTopButton from "../components/ScrollTopButton";

function Homepage() {
  return (
    <div>
      <Navigation />
      <Hero />
      <Brand />
      <Features />
      <Stories />
      <Steps />
      <Testimonial />
      <Pricing />
      <Subscribe />
      <Faqs />
      <Contact />
      <Footer />
      <ScrollTopButton />
    </div>
  );
}

export default Homepage;
